import { ALL_KNOWN_DETAILS_TESTIDS } from '../../constants';
import styles from './SourceAttribution.module.scss';

/** Names the source behind a value shown outside the drawer, in the overflow popover's muted
 *  dot-separated language. Renders nothing when no source claims the value. */
const SourceAttribution = ({ source }: { source?: string }) => {
    if (!source) return null;

    return (
        <span className={styles.Attribution} data-testid={ALL_KNOWN_DETAILS_TESTIDS.SOURCE_ATTRIBUTION}>
            <span className={styles.Dot} aria-hidden="true">
                ·
            </span>
            <span className={styles.Source}>{source}</span>
        </span>
    );
};

export default SourceAttribution;
